import CardActions from '@mui/material/CardActions';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { AddGroup } from '../../api/groups-endpoint';
import SnackbarAlert from '../../components/Alerts';
import CancelButton from '../../components/CancelButton';
import GroupDetails from '../../components/groups/GroupDetails';
import useConfigStyles from '../../components/useConfigStyles';
import SubmitButton from '../../components/SubmitButton';
import { getLinkToGroup } from '../../navigator/links';
import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGroupsContext } from '../../stores/groups-context';
import { Group } from '../../types/group';
import { defaultGroup } from '../../types/defaultValues';

function GroupEditPage(): JSX.Element {
  const [group, setGroup] = useState<Group>(defaultGroup);
  const [responseMessage, setResponseMessage] = useState('');
  const [notify, toggleNotification] = useState(false);
  const [errors, setErrors] = useState<Record<string, string[]>>({});
  const classes = useConfigStyles();
  const navigate = useNavigate();
  const groupsContext = useGroupsContext();

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const response = await AddGroup(group);
    if (response.success) {
      setResponseMessage('Success');
      groupsContext.fetchData();
      navigate(getLinkToGroup(group.Name));
    } else {
      setResponseMessage(response.message || '');
      setErrors(response.errors || {});
    }
    toggleNotification(true);
  };

  const handleCloseSnackbar = () => {
    toggleNotification(false);
  };

  const handleCancelClick = () => {
    navigate(-1);
  };

  const cleanErrors = (name: string) => {
    if (errors[name]) {
      delete errors[name];
    }
  };

  const handleGroupUpdate = (updatedGroup: Group, fieldName?: string) => {
    setGroup(updatedGroup);
    if (fieldName) {
      cleanErrors(fieldName);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={classes.form}>
      <Card>
        <CardContent>
          <GroupDetails group={group} editable errors={errors} onGroupUpdate={handleGroupUpdate} />
        </CardContent>
        <CardActions style={{'marginBottom': '24px'}}>
          <Grid container alignItems='center' justifyContent='center' direction='row' spacing={5}>
            <Grid item>
              <CancelButton label='Back' className={classes.button} onClick={handleCancelClick} />
            </Grid>
            <Grid item>
              <SubmitButton className={classes.button} label='Create Group' />
            </Grid>
          </Grid>
        </CardActions>
      </Card>
      <SnackbarAlert open={notify} message={responseMessage} handleClose={handleCloseSnackbar} />
    </form>
  );
}

export default GroupEditPage;
